export type NavItem = {
  label: string;
  href: string;
};

export const navigation: NavItem[] = [
  { label: "Služby a benefity", href: "#sluzby" },
  { label: "Jak pracujeme", href: "#jak-pracujeme" },
  { label: "Ukázka", href: "#ukazka" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontakt", href: "#kontakt" },
];

export const primaryCta = {
  label: "Konzultace zdarma",
  href: "#kontakt",
} as const;
